enum PaymentResult {
    redirectToECPay = "redirectToECPay", 
    redirectToNewebPay = "redirectToNewebPay", 
    redirect = "redirect", 
    refresh = "refresh"
}

export default PaymentResult